import React from 'react'
import { Router } from 'react-static'
import { hot } from 'react-hot-loader'

import './app.css'

import AppLayout from './app-layout'

const App = () => (
  <Router type="browser">
    <AppLayout />
  </Router>
)

export default hot(module)(App)



// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/src/App.js